import type { SuggestedQuestion } from "../../../services/interfaces/doti/doti.sendmessage.interface"

// suggested_questions
export const mapSuggestedQuestions = (suggestedQuestions: SuggestedQuestion[]) => {
    return suggestedQuestions.map((question) => question.content)
}